import { motion } from "motion/react";
import { Heart, ExternalLink } from "lucide-react";
import { openSourceProjects, openSourceCopy } from "../lib/landingData";
import { BrandLogo } from "../components/BrandLogo";

export function OpenSourceSection() {
  return (
    <section className="relative py-32 px-4 sm:px-6 lg:px-8 overflow-hidden border-y border-white/5">
      <div className="absolute inset-0 bg-gradient-to-b from-background via-primary/5 to-background pointer-events-none" />

      <div className="relative z-10 max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full border border-primary/30 bg-primary/10 text-primary text-sm font-medium mb-6">
            {openSourceCopy.badge}
            <Heart className="h-4 w-4 fill-primary text-primary" />
          </div>
          <h2 className="text-4xl sm:text-5xl lg:text-6xl font-black tracking-tighter text-foreground mb-6">
            {openSourceCopy.headline}
          </h2>
          <p className="text-lg sm:text-xl text-muted-foreground max-w-3xl mx-auto leading-relaxed">
            {openSourceCopy.subheadline}
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.1 }}
          className="flex flex-wrap items-center justify-center gap-4 mb-16"
        >
          {openSourceProjects.map((brand) => (
            <BrandLogo
              key={brand.name}
              name={brand.name}
              slug={brand.slug}
              iconColor={brand.iconColor}
            />
          ))}
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="max-w-3xl mx-auto text-center"
        >
          <div className="rounded-2xl border border-white/10 bg-white/5 backdrop-blur-md p-8 sm:p-12">
            <p className="text-xl sm:text-2xl font-bold text-foreground mb-4">
              &ldquo;Open source is how we build the future together.&rdquo;
            </p>
            <p className="text-muted-foreground mb-6">
              If you maintain, contribute to, or rely on open source software — thank you.
              FlowState wouldn&apos;t exist without the libraries, runtimes, and communities that share their work freely.
            </p>
            <a
              href="https://github.com/flowstate-automate"
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center gap-2 text-sm font-medium text-primary hover:text-primary/80 transition-colors"
            >
              Explore our GitHub
              <ExternalLink className="h-4 w-4" />
            </a>
          </div>
          <p className="text-xs text-muted-foreground mt-8 max-w-2xl mx-auto">
            {openSourceCopy.disclaimer}
          </p>
        </motion.div>
      </div>
    </section>
  );
}
